import {writable} from 'svelte/store';

let appObject = {
    page: '',
    page_loader: false,
    popup_loader: false,
    todoExpanded: false,
    todos: 0,
    menuExpanded: 0,
    users: [],
    viewBy: 0,
};

const {get, set, update, subscribe} = writable(appObject);

const app = {
    set,
    update,
    subscribe,

    // initialize: () => {
        // app.update(obj => {
        //     let coo = JSON.parse(cookie.get('ew-admin') || "{}");
        //     obj.token = coo.token;
        //     obj.api_index = coo.api_index || 0;
        //     return obj;
        // });
    // },
    //
    // setToken: (token) => {
    //     app.update(obj => {
    //         obj.token = token;
    //         app.saveCookie();
    //         return obj;
    //     });
    // },
    //
    // clearToken: () => {
    //     app.update(obj => {
    //         obj.token = null;
    //         app.saveCookie();
    //         return obj;
    //     });
    // },
    //
    // saveCookie: () => {
    //     let coo = {
    //         api_index: appObject.api_index,
    //         token: appObject.token
    //     };
    //     cookie.create('ew-admin', JSON.stringify(coo));
    // },

    getViewBy: () => {
        return appObject.viewBy;
    },
    setViewBy: id => {
        app.update(obj => {
            obj.viewBy = id;
            return obj;
        });
    },

    showPageLoader: () => {
        app.update(obj => {
            obj.page_loader = true;
            return obj;
        });
    },
    hidePageLoader: () => {
        // setTimeout(function () {
        app.update(obj => {
            obj.page_loader = false;
            return obj;
        });
        // }, 500);
    },
    showPopupLoader: () => {
        app.update(obj => {
            obj.popup_loader = true;
            return obj;
        });
    },
    hidePopupLoader: () => {
        app.update(obj => {
            obj.popup_loader = false;
            return obj;
        });
    },

    windowResize: () => {
        app.update(obj => {
            let win = window,
                doc = document,
                docElem = doc.documentElement,
                body = doc.getElementsByTagName('body')[0];

            obj.docWidth = win.innerWidth || docElem.clientWidth || body.clientWidth,
            obj.docHeight = win.innerHeight|| docElem.clientHeight|| body.clientHeight;

            if (obj.docWidth > 1199) {
                obj.device = "lg";
            } else if (obj.docWidth > 991) {
                obj.device = "md";
            } else if (obj.docWidth > 767) {
                obj.device = "sm";
            } else {
                obj.device = "xs";
            }

            return obj;
        })
    },

    getUser: (id) => {
        return appObject.users.find(u => u.id === id);
    },

//     setCurrentPage: () => {
//         let parts = document.URL.split(/[?#]+/);
//         let paths = parts[0].split('/');
// console.log("set page");
//         app.update(obj => {
//             obj.page = paths[paths.length - 1];
//             return obj;
//         });
//     }
}

export default app;